<template>
  <section>
    <box-default>
      <div class="col-md-12 fp">

        <div class="fp-head">
          <div class="fp-head__title">
            <ion-icon name="pulse-outline"/>
            <div>
              <h3>Telemetria — POC Reconhecimento Facial</h3>
              <span>Resultado do job que valida o identify da Zioncor contra os pontos reais</span>
            </div>
          </div>
          <button class="fp-btn fp-btn--ghost" :disabled="running" @click="runNow()">
            <span v-if="!running">Rodar agora</span>
            <span v-else>Executando...</span>
          </button>
        </div>

        <div v-if="enqueued" class="fp-run">
          <ion-icon name="play-circle-outline"/>
          <span>{{ enqueued }}</span>
          <button class="fp-x" @click="enqueued = ''"><ion-icon name="close-outline"/></button>
        </div>

        <div class="fp-card fp-filters">
          <div class="fp-field">
            <label>De</label>
            <input v-model="from" type="datetime-local"/>
          </div>
          <div class="fp-field">
            <label>Até</label>
            <input v-model="to" type="datetime-local"/>
          </div>
          <div class="fp-field fp-field--grow">
            <label>Empresa (opcional)</label>
            <input v-model="companyId" type="text" placeholder="companyId"/>
          </div>
          <div class="fp-field">
            <label>Banco (opcional)</label>
            <input v-model="bank" type="text" list="fp-banks" placeholder="todos"/>
            <datalist id="fp-banks">
              <option v-for="b in banks" :key="b" :value="b"></option>
            </datalist>
          </div>
          <button class="fp-btn" :disabled="loading" @click="load()">
            <span v-if="!loading">Buscar</span>
            <span v-else>Buscando...</span>
          </button>
        </div>

        <waiting-list :loading-content="loading">

          <div v-if="data" class="fp-kpis">
            <div class="fp-kpi fp-kpi--hero">
              <span>Acurácia</span>
              <strong :class="accuracyClass">{{ data.accuracyPct }}%</strong>
              <small>acertos sobre identifies decididos</small>
            </div>
            <div class="fp-kpi"><span>Acertos</span><strong class="fp-ok">{{ data.samePerson }}</strong></div>
            <div class="fp-kpi"><span>Divergências</span><strong class="fp-bad">{{ data.otherPerson }}</strong></div>
            <div class="fp-kpi"><span>Sem match</span><strong class="fp-warn">{{ data.notMatched }}</strong></div>
            <div class="fp-kpi"><span>Falhas</span><strong>{{ data.failures }}</strong></div>
            <div class="fp-kpi"><span>Identifies</span><strong>{{ data.totalIdentify }}</strong></div>
            <div class="fp-kpi"><span>Cadastros</span><strong>{{ data.totalEnroll }}</strong></div>
            <div class="fp-kpi"><span>Score médio</span><strong>{{ data.avgScore }}</strong></div>
            <div class="fp-kpi"><span>Tempo médio</span><strong>{{ data.avgElapsedMs }} ms</strong></div>
          </div>

          <div v-if="data && data.failedBanks && data.failedBanks.length" class="fp-msgs fp-msgs--bad">
            <div v-for="(b, i) in data.failedBanks" :key="i">{{ b }}</div>
          </div>

          <div v-if="entries.length" class="fp-card">
            <div class="fp-card__head">
              <h4>Registros ({{ entries.length }})</h4>
              <span class="fp-card__hint">
                <template v-if="data.truncated">listagem cortada — os indicadores acima cobrem o período inteiro · </template>
                tentativa 2 = após cadastro de bootstrap
              </span>
            </div>

            <div class="fp-tablewrap">
              <table class="fp-table">
                <thead>
                  <tr>
                    <th>Resultado</th>
                    <th>Data do ponto</th>
                    <th>Esperado</th>
                    <th>Identificado</th>
                    <th>Score</th>
                    <th>Limiar</th>
                    <th>Base</th>
                    <th>Origem</th>
                    <th>Tent.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(e, i) in entries" :key="i">
                    <td><span class="fp-tag" :class="outcomeClass(e)">{{ outcomeLabel(e) }}</span></td>
                    <td class="fp-nowrap">{{ e.pointDate }}</td>
                    <td>
                      <div class="fp-person">{{ e.expectedUserName || '—' }}</div>
                      <div class="fp-mono fp-dim">{{ e.expectedUserId }}</div>
                    </td>
                    <td>
                      <div class="fp-person">{{ e.returnedName || '—' }}</div>
                      <div class="fp-mono fp-dim">{{ e.returnedExternalId || '' }}</div>
                    </td>
                    <td>{{ num(e.score) }}</td>
                    <td>{{ num(e.threshold) }}</td>
                    <td>{{ e.baseSize }}</td>
                    <td class="fp-nowrap">{{ e.fromWhere }}</td>
                    <td>{{ e.attempt }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-else-if="data && !loading" class="fp-empty">
            <ion-icon name="analytics-outline"/>
            <span>Nenhum registro da POC no período.</span>
          </div>

        </waiting-list>
      </div>
    </box-default>
  </section>
</template>

<script>
import BoxDefault from "../../components/layouts/boxDefault.vue";
import WaitingList from "../../components/layouts/waitingList.vue";
import {FACE_LAB_POC_RUN, FACE_LAB_POC_TELEMETRY} from "../../../../urlConfig";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import {ALERT_SERVICE} from "../../../../msgAlertService";

export default {
  name: "faceLabPoc",
  components: {BoxDefault, WaitingList},
  data() {
    return {
      banks: ["AAAA", "MMMM", "QQQQ", "RRRR", "TTTT", "XXXX", "NNNN", "EEEE"],
      from: "",
      to: "",
      companyId: "",
      bank: "",
      loading: false,
      running: false,
      data: null,
      enqueued: ""
    };
  },
  computed: {
    entries() {
      if (!this.data || !this.data.entries) return [];
      return this.data.entries;
    },
    accuracyClass() {
      if (!this.data) return "";
      if (this.data.accuracyPct >= 90) return "fp-ok";
      if (this.data.accuracyPct >= 70) return "fp-warn";
      return "fp-bad";
    }
  },
  methods: {
    load() {
      this.loading = true;

      let url = FACE_LAB_POC_TELEMETRY + "?take=300";
      if (this.from) url += "&from=" + encodeURIComponent(this.from.replace("T", " "));
      if (this.to) url += "&to=" + encodeURIComponent(this.to.replace("T", " "));
      if (this.companyId) url += "&companyId=" + encodeURIComponent(this.companyId.trim());
      if (this.bank) url += "&bank=" + encodeURIComponent(this.bank.trim().toUpperCase());

      REQUEST_SERVICE.get(url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT FACE_LAB_POC_TELEMETRY:", response.data);
          this.data = response.data || null;
          this.loading = false;
        })
        .catch((reason) => {
          this.loading = false;
          this.apiError(reason, "Não foi possível carregar a telemetria.");
        });
    },

    runNow() {
      this.running = true;
      this.runResult = null;

      REQUEST_SERVICE.post(FACE_LAB_POC_RUN + "?minutes=30", {})
        .then((response) => {
          UTIL_SERVICE.console("RESULT FACE_LAB_POC_RUN:", response.data);
          this.running = false;
          this.enqueued = typeof response.data === "string" ? response.data : "Rodada enfileirada.";

          // A janela do filtro foi montada no mounted(); sem reavançar a ponta direita,
          // o que a rodada acabou de gravar cairia fora do intervalo consultado.
          this.to = this.toLocalInput(new Date());
          this.load();
        })
        .catch((reason) => {
          this.running = false;
          this.apiError(reason, "Não foi possível executar a POC.");
        });
    },

    outcomeLabel(e) {
      if (e.errorMessage) return "Falha";
      if (!e.matched) return "Sem match";
      return e.isSamePerson ? "Acerto" : "Divergência";
    },

    outcomeClass(e) {
      if (e.errorMessage) return "fp-tag--err";
      if (!e.matched) return "fp-tag--warn";
      return e.isSamePerson ? "fp-tag--ok" : "fp-tag--bad";
    },

    num(value) {
      const n = Number(value);
      if (isNaN(n)) return "—";
      return n.toFixed(4).replace(/0+$/, "").replace(/\.$/, "");
    },

    apiError(reason, fallback) {
      let msg = fallback;

      try {
        const data = reason && reason.response ? reason.response.data : null;
        if (data) {
          if (data.erros && data.erros.length) msg = data.erros.map(e => e.value).join(" ");
          else if (data.message) msg = data.message;
          else if (typeof data === "string" && data.length) msg = data;
        }
      } catch (e) {
        msg = fallback;
      }

      ALERT_SERVICE.swal("Ops...", msg, "error");
    },

    defaultRange() {
      const now = new Date();
      const start = new Date(now.getTime() - 24 * 60 * 60 * 1000);
      this.from = this.toLocalInput(start);
      this.to = this.toLocalInput(now);
    },

    toLocalInput(d) {
      const pad = (n) => (n < 10 ? "0" + n : "" + n);
      return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate())
        + "T" + pad(d.getHours()) + ":" + pad(d.getMinutes());
    }
  },
  mounted() {
    this.defaultRange();
    this.load();
  }
};
</script>

<style lang="scss" scoped>
* { font-family: "Montserrat", sans-serif !important; }

$blue: #2F23D6;
$green: #2ACC6B;
$red: #FF445D;
$orange: #FF9900;
$grayText: #7E8DA7;
$dark: #3A424E;

.fp {
  padding-bottom: 40px;

  ion-icon { pointer-events: none; }

  &-card {
    background: #fff;
    border-radius: 10px !important;
    padding: 18px 20px;
    margin-bottom: 18px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .10), 0 0 0 1px rgba(0, 0, 0, .05);

    &__head {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      margin-bottom: 14px;

      h4 { margin: 0; font-size: 15px; font-weight: 700; color: $dark; }
    }

    &__hint { font-size: 12px; color: $grayText; }
  }
}

.fp-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 6px 0 18px;

  &__title {
    display: flex;
    align-items: center;
    gap: 14px;

    ion-icon { font-size: 38px; color: $blue; }
    h3 { margin: 0; font-size: 20px; font-weight: 700; color: $dark; }
    span { font-size: 13px; color: $grayText; }
  }
}

.fp-run {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #F4F3FE;
  color: $blue;
  border-radius: 8px !important;
  padding: 10px 14px;
  margin-bottom: 14px;
  font-size: 13px;

  ion-icon { font-size: 20px; flex: 0 0 auto; }
}

.fp-msgs {
  background: #FFF7DA;
  color: #8a6d00;
  border-radius: 8px !important;
  padding: 10px 14px;
  margin-bottom: 14px;
  font-size: 12px;

  &--bad { background: #fde8e8; color: #c0392b; }
  div { margin: 2px 0; }
}

.fp-filters {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  flex-wrap: wrap;
}

.fp-field {
  display: flex;
  flex-direction: column;
  gap: 6px;

  &--grow { flex: 1 1 240px; }

  label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: $grayText;
    margin: 0;
  }

  input {
    height: 38px;
    padding: 0 12px;
    border: 1px solid #DDE3EC;
    border-radius: 8px !important;
    font-size: 13px;
    color: $dark;
    outline: none;

    &:focus { border-color: $blue; }
  }
}

.fp-btn {
  height: 38px;
  padding: 0 20px;
  border: none;
  border-radius: 8px !important;
  background: $blue;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;

  &:hover:enabled { opacity: .88; }
  &:disabled { background: #BFC7D4; cursor: not-allowed; }

  &--ghost {
    background: #fff;
    color: $blue;
    border: 1px solid #DDE3EC;
    &:disabled { background: #fff; color: #BFC7D4; }
  }
}

.fp-x {
  border: none;
  background: transparent;
  cursor: pointer;
  color: inherit;
  margin-left: auto;

  ion-icon { font-size: 18px; }
}

.fp-kpis {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 18px;
}

.fp-kpi {
  flex: 1 1 120px;
  min-width: 110px;
  background: #fff;
  border-radius: 10px !important;
  padding: 14px 16px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .10), 0 0 0 1px rgba(0, 0, 0, .05);

  span { display: block; font-size: 10px; font-weight: 700; text-transform: uppercase; color: $grayText; }
  strong { display: block; font-size: 22px; font-weight: 700; margin-top: 6px; color: $dark; }
  small { display: block; font-size: 10px; color: $grayText; margin-top: 2px; }

  &--hero { flex: 1 1 200px; strong { font-size: 34px; } }
}

.fp-ok { color: #08A747 !important; }
.fp-warn { color: #B58A00 !important; }
.fp-bad { color: #c0392b !important; }

.fp-tablewrap { overflow-x: auto; }

.fp-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;

  th {
    text-align: left;
    font-size: 10px;
    text-transform: uppercase;
    color: $grayText;
    border-bottom: 1px solid #EFF2F6;
    padding: 8px 10px;
    white-space: nowrap;
  }

  td {
    border-bottom: 1px solid #F5F7FA;
    padding: 8px 10px;
    color: $dark;
    vertical-align: top;
  }
}

.fp-person { font-weight: 600; }
.fp-dim { color: $grayText; font-size: 10px; word-break: break-all; }
.fp-nowrap { white-space: nowrap; }
.fp-mono { font-family: "Courier New", monospace !important; }

.fp-tag {
  display: inline-block;
  border-radius: 4px !important;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;

  &--ok { background: #E6F8EE; color: #08A747; }
  &--bad { background: #fde8e8; color: #c0392b; }
  &--warn { background: #FFF7DA; color: #B58A00; }
  &--err { background: #EFF2F6; color: #7E8DA7; }
}

.fp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 40px 0;
  color: $grayText;

  ion-icon { font-size: 42px; }
  span { font-size: 13px; }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/faceLab/faceLabPoc.vue